module.exports = __webpack_public_path__ + "img/domestic-2018-nanjing-summit.829e9487.jpg";